module.exports = __webpack_public_path__ + "static/media/LinkedInLogo.53e7a670.png";